export const SET_TOGGLE_FETCHING = 'MEAL:SET_TOGGLE_FETCHING';
export const SET_MEAL = 'MEAL:SET_MEAL';
export const SET_CLEAR = 'MEAL:SET_CLEAR';
export const ADD_ERROR = 'MEAL:ADD_ERROR';